<template>
    <v-dialog max-width="400" :value="value" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Resetta Setup
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="reset3()">
                      <v-icon color="error">mdi-restart</v-icon>
                  </v-btn>
                  </template>
                  <span>Cancella tutti i dati e Riesegui SetUp</span>
              </v-tooltip>   
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.native="$emit('input', false)">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="12" cols="12">
                    <p class="text-subtitle-1 font-weight-black error--text">
                      Attenzione!! <br>Cliccando su Esegui tutte le impostazioni presenti verranno resettate ai valori di default
                    </p>
                </v-col>
            </v-row>
        </v-card> 
    </v-dialog>   
</template>
<script>
export default {
    props:['value'],
    data () {
    return {
      dialog:false,
    }},
    methods:
    {
        reset3()
        {
          console.log(415,this.editedItem2)
          this.loading_update=true;
          this.$emit('reset3');
          this.$emit('input', false)
        },
    }
}
</script>